<template>
  <div
    class="input-wrapper all-day-wrapper timing-wrapper office-loaction pl-0"
  >
    <div class="custom-input-wrapper input-wrapper">
      <label class="container-radio" @click="setIsOfficeLocal">
        <span class="checkmark" :class="{ checked: isOffice }"></span> Office
      </label>
      <label class="container-radio" @click="setIsVideoLocal">
        <span class="checkmark" :class="{ checked: isVideo }"></span> Video
      </label>
      <label class="container-radio" @click="setIsPhone">
        <span class="checkmark" :class="{ checked: isPhone }"></span> Phone
      </label>
      <label class="container-radio" @click="setIsOther">
        <span class="checkmark" :class="{ checked: isOther }"></span> Other
      </label>
    </div>
  </div>
</template>

<script>
import { providerDependentMixin } from "../../../../mixins/providerDependentMixin";
import { mapGetters, mapMutations } from "vuex";

export default {
  mixins: [providerDependentMixin],
  computed: {
    ...mapGetters({
      isVideo: "getIsVideo", // If video is selected
      isOffice: "getIsOffice", // If office is selected
      isPhone: "getIsPhone", // If phone is selected,
      isOther: "getIsOther", // If other is selected
      addVideoAppointmentPermission: "getAddVideoAppointmentPermission" // Get weather the user has permission to add video appointment
    })
  },
  methods: {
    ...mapMutations({
      setIsVideo: "setIsVideo", // Set if appointment is video
      setIsOffice: "setIsOffice", // Set if appointment is office
      setIsPhone: "setIsPhone", // Set if appointment is phone,
      setIsOther: "setIsOther", // Set if the appointment is other
      setUsePsybooksVideo: "setUsePsybooksVideo", // Use psybooks video
      setUseConnectVideo: "setUseConnectVideo"
    }),
    setIsOfficeLocal() {
      this.setIsOffice();
    },
    setIsVideoLocal() {
      if (this.addVideoAppointmentPermission) {
        // Set psybooks video as default
        this.setUsePsybooksVideo(true);
        this.setUseConnectVideo(true);
      }
      this.setIsVideo();
    }
  },
  mounted() {
    const { is_video } = this.selectedValue;
    if (is_video) {
      this.setIsVideo();
      if (this.addVideoAppointmentPermission) {
        // Set psybooks video as default
        this.setUsePsybooksVideo(true);
        this.setUseConnectVideo(true);
      }
    }
  },
  watch: {
    /**
     * When the selected value is updated
     * Change the search term
     * Select video for video group
     */
    selectedValue({ is_video }) {
      if (is_video) {
        this.setIsVideo();
        if (this.addVideoAppointmentPermission) {
          // Set psybooks video as default
          this.setUsePsybooksVideo(true);
          this.setUseConnectVideo(true);
        }
      }
    }
  }
};
</script>
